import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const PreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 500px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  overflow: hidden;
  width: 100%;
  max-width: 280px;

  @media (max-width: 768px) {
    max-width: none;
    height: 400px;
  }
`;

export const PreviewHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: between;
  padding: 12px 16px;
  background: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
  min-height: 48px;
`;

export const PreviewTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
`;

export const PreviewContent = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const PreviewFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  background: #fff;

  /* Center the content horizontally for better visibility */
  display: block;
  margin: 0 auto;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #666;
  text-align: center;
  padding: 40px 20px;

  span {
    font-size: 16px;
    font-weight: 500;
  }

  small {
    font-size: 14px;
    color: #999;
    max-width: 300px;
    line-height: 1.4;
  }
`;

export const LoadingState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: #666;

  .spinner {
    width: 32px;
    height: 32px;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #2ec9b7;
    border-radius: 50%;
    animation: ${spin} 1s linear infinite;
  }

  span {
    font-size: 14px;
    font-weight: 500;
  }
`;
